import { AxiosResponse } from 'axios';
import TourType from '../../types/admin/tour.type';
import { CommonFilterCriteria, PageRequest, PaginationResponseType } from '../../types/CommonTypes';
import { API_ADMIN_TOURS } from '../../utils/urls';
import { get } from '../baseAxios';

const url = API_ADMIN_TOURS;

export const getAdminTour = (id: number): Promise<AxiosResponse<TourType>> => get(`${url}/${id}`);
export const getAdminTours = (
  params: CommonFilterCriteria & PageRequest
): Promise<AxiosResponse<PaginationResponseType<TourType>>> => get(url, { params });
